import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type WorkflowContextResourceV2 = OpalApiComponent<'V2', 'context'>

export const workflowContextResourceFactory: Factory<WorkflowContextResourceV2> =
  Factory.define<WorkflowContextResourceV2>(({ sequence }) => {
    const now = new Date().toISOString()
    return {
      id: uuidV4(),
      type: 'context',
      attributes: { created_at: now, deleted_at: null, updated_at: now },
      relationships: {
        created_by_user: { data: { id: uuidV4(), type: 'user' } },
        moment: { data: { id: `${sequence}`, type: 'moment' } },
      },
    } satisfies WorkflowContextResourceV2
  })
